import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { message } from 'antd';

import Navbar from '../Navbar/NavBar';
import DataOpsTable from './DataOpsTable';
import FiltersDataOps from './FiltersDataOps';
import ModalEditEntities from './ModalEditEntities';

import { LOAD_DATAOPS_TIME } from '../../config/constants';

import { useInterval, useEventListener } from '../../helpers/customHooks';
import { useDataOpsDispatch, useDataOpsState } from '../../store/hooks/dataOps';
import { useFlagsDispatch, useFlagsState } from '../../store/hooks/flags';

import './DataOps.scss';
import { PracticeDataOps } from './types';

export default () => {
  const { dataOpsRedux } = useDataOpsState();
  const data:Array<PracticeDataOps> = Object.values(dataOpsRedux);
  const { messageFromAction, actionSucceeded } = useFlagsState();
  const { getDataOps } = useDataOpsDispatch();
  const {  hideActionStartedMessage } = useFlagsDispatch();

  const [hidden, setHidden] = useState(false);
  const [activeChecked, setActiveChecked] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState(false);
  const [practiceOnModal, setPracticeOnModal] = useState<PracticeDataOps | null>(null);

  const handleModalOpening = (practice:PracticeDataOps) => {
    setPracticeOnModal(practice);
    setModalShow(true);
  };

  const onModalClose = () => {
    setModalShow(false);
    setPracticeOnModal(null);
  };

  useEffect(() => {
    if (actionSucceeded === true) {
      message.success({
        content: messageFromAction,
        className: 'message-pro',
        style: {
          marginTop: '60vh'
        }
      }, 100);
      hideActionStartedMessage();
    } else if (actionSucceeded === false) {
      message.error({
        content: messageFromAction,
        className: 'message-pro-error',
        style: {
          marginTop: '60vh'
        }
      }, 100);
      hideActionStartedMessage();
    }
  }, [actionSucceeded]);

  useEffect(() => {
    getDataOps(true);
  }, []);
  useEventListener('visibilitychange', () => {
    if (!document.hidden) {
      getDataOps(false);
    }
    setHidden(document.hidden);
  });
  useInterval(() => {
    getDataOps(false);
  }, !hidden ? LOAD_DATAOPS_TIME : null);

  return (<>
    <Navbar />
    <Container className="container-00">
      <Row>
        <Col lg={12} xs={12}>
          <div className="profiles-pp">
            <h4>Data Ops</h4>
          </div>
          <FiltersDataOps loadData={getDataOps} activeChecked={activeChecked} setActiveChecked={setActiveChecked} />
          {practiceOnModal &&
          <ModalEditEntities
            show={modalShow}
            practice={practiceOnModal}
            onModalClose={onModalClose} />}
          <div className="data-op entities-f adjust-height-data-ops-table">
            <DataOpsTable
              data={data}
              activeChecked={activeChecked}
              handleModalOpening={handleModalOpening}
            />
          </div>
        </Col>
      </Row>
    </Container>
  </>);
};
